var pdf = "https://shopfront-cdn.tekoapis.com/static/c88ca7dfb6a0adbd.svg";

export { pdf as default };
